module.exports = __webpack_public_path__ + "img/SKWINKELNetActieActieplanning5FA7C4.1735b669.png";